<div [formGroup]="parentForm">
  <div class="da-card">
    <h3 class="card-title" style="margin-bottom: 8px;">Test Scores</h3>
    <hr class="dashed-line">
    
    <div class="field-group mb-16">
      <label>Have you taken an English Language Proficiency (ELP) test? <span class="required">*</span></label>
      <div style="margin-top: 8px;">
        <p-selectButton [options]="yesNoOptions" formControlName="hasElpTest" optionLabel="label" optionValue="value"
          [class.ng-invalid]="isFieldInvalid(parentForm, 'hasElpTest')"
          [class.ng-dirty]="isFieldInvalid(parentForm, 'hasElpTest')"></p-selectButton>
        <app-field-error [control]="parentForm.get('hasElpTest')" type="requiredOnly" fieldName="This selection"></app-field-error>
      </div>
    </div>

    <div formArrayName="testScores" *ngIf="parentForm.get('hasElpTest')?.value">
  <div class="scorecard-label">SCORECARD</div>
  <div *ngFor="let ts of testScores.controls; let i=index" [formGroupName]="i">
    <div class="error-msg" *ngIf="ts.errors?.['noScore'] && (ts.touched || ts.dirty)" style="margin-bottom: 16px;">
      <span>At least one test score is required</span>
    </div>
    <div class="ts-score-list">

      <!-- IELTS -->
      <div class="ts-score-block">
        <label>IELTS Overall Band Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="ieltsScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'ieltsScore') || (ts.errors?.['missingScore_ieltsScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'ieltsScore') || (ts.errors?.['missingScore_ieltsScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('ieltsScore')" type="testScore" fieldName="IELTS score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_ieltsScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'ieltsDoc', label: 'IELTS_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_ieltsScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- TOEFL -->
      <div class="ts-score-block">
        <label>TOEFL Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="toeflScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'toeflScore') || (ts.errors?.['missingScore_toeflScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'toeflScore') || (ts.errors?.['missingScore_toeflScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('toeflScore')" type="testScore" fieldName="TOEFL score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_toeflScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'toeflDoc', label: 'TOEFL_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_toeflScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Duolingo -->
      <div class="ts-score-block">
        <label>Duolingo Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="duolingoScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'duolingoScore') || (ts.errors?.['missingScore_duolingoScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'duolingoScore') || (ts.errors?.['missingScore_duolingoScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('duolingoScore')" type="testScore" fieldName="Duolingo score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_duolingoScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'duolingoDoc', label: 'Duolingo_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_duolingoScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- AP Exam -->
      <div class="ts-score-block">
        <label>AP Exam Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="apExamScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'apExamScore') || (ts.errors?.['missingScore_apExamScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'apExamScore') || (ts.errors?.['missingScore_apExamScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('apExamScore')" type="testScore" fieldName="AP score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_apExamScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'apDoc', label: 'AP_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_apExamScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- SAT -->
      <div class="ts-score-block">
        <label>SAT Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="satScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'satScore') || (ts.errors?.['missingScore_satScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'satScore') || (ts.errors?.['missingScore_satScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('satScore')" type="testScore" fieldName="SAT score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_satScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'satDoc', label: 'SAT_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_satScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- GRE -->
      <div class="ts-score-block">
        <label>GRE Total Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="greTotalScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'greTotalScore') || (ts.errors?.['missingScore_greTotalScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'greTotalScore') || (ts.errors?.['missingScore_greTotalScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('greTotalScore')" type="testScore" fieldName="GRE score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_greTotalScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'greDoc', label: 'GRE_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_greTotalScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- GMAT -->
      <div class="ts-score-block">
        <label>GMAT Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="gmatScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'gmatScore') || (ts.errors?.['missingScore_gmatScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'gmatScore') || (ts.errors?.['missingScore_gmatScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('gmatScore')" type="testScore" fieldName="GMAT score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_gmatScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'gmatDoc', label: 'GMAT_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_gmatScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ACT -->
      <div class="ts-score-block">
        <label>ACT Score</label>
        <div class="ts-score-row">
          <div style="flex: 1;">
            <input pInputText formControlName="actScore"
              [class.ng-invalid]="isFieldInvalid(ts, 'actScore') || (ts.errors?.['missingScore_actScore'] && (ts.touched || ts.dirty))"
              [class.ng-dirty]="isFieldInvalid(ts, 'actScore') || (ts.errors?.['missingScore_actScore'] && (ts.touched || ts.dirty))" />
            <app-field-error [control]="ts.get('actScore')" type="testScore" fieldName="ACT score"></app-field-error>
            <div class="error-msg" *ngIf="ts.errors?.['missingScore_actScore'] && (ts.touched || ts.dirty)">
              <span>Score is required when document is uploaded</span>
            </div>
          </div>
          <div class="ts-score-doc">
            <ng-container *ngTemplateOutlet="docUpload; context: { $implicit: i, field: 'actDoc', label: 'ACT_Scorecard.pdf' }"></ng-container>
            <div class="error-msg" *ngIf="ts.errors?.['missingDoc_actScore'] && (ts.touched || ts.dirty)" style="margin-top: 4px;">
              <span>Document is required</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1.5rem; padding-bottom: 0.5rem;" *ngIf="parentForm.get('hasElpTest')?.value !== null && parentForm.get('hasElpTest')?.value !== undefined">
  <button pButton type="button" 
          [label]="isDataExists ? 'Update' : 'Save'"
          icon="pi pi-check"
          class="p-button-sm p-button-primary"
          [loading]="isSaving"
          [disabled]="isSaving"
          style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
          (click)="saveTestScores()">
  </button>
</div>
<div class="unsaved-warning" *ngIf="parentForm.get('hasElpTest')?.value !== null && parentForm.get('hasElpTest')?.value !== undefined && (testScores.dirty || parentForm.get('hasElpTest')?.dirty)">
  You have unsaved changes. Please click {{ isDataExists ? 'Update' : 'Save' }} to continue.
</div>

</div>
<p-toast></p-toast>

<!-- Reusable doc upload template -->
<ng-template #docUpload let-i let-field="field" let-label="label">
  <input type="file" style="display:none"
    #fileInput
    accept=".pdf,.doc,.docx"
    (change)="onFileSelectedForTest($event, field, fileInput)">

  <!-- Has file -->
  <div class="doc-cell has-file" *ngIf="getDocValue(i, field) as docVal">
    <img src="assets/doc-icon.png" class="doc-icon" alt="doc">
    <div class="doc-info">
      <span class="doc-name" (click)="openFile(docVal)">{{ label }}</span>
      <span class="doc-meta">Uploaded <i class="pi pi-check-circle" style="color:#16a34a"></i></span>
    </div>
    <button class="replace-btn" (click)="fileInput.click()">Replace</button>
  </div>

  <!-- No file -->
  <div class="doc-cell no-file" *ngIf="!getDocValue(i, field)">
    <img src="assets/doc-icon.png" class="doc-icon faded" alt="doc">
    <div class="doc-info">
      <span class="doc-name muted">{{ label }}</span>
      <span class="doc-meta warn"><i class="pi pi-upload" style="font-size:11px"></i> No file</span>
    </div>
    <button class="replace-btn" (click)="fileInput.click()">Upload</button>
  </div>
</ng-template>

<!-- PDF Preview Dialog -->
<p-dialog [(visible)]="displayPreviewDialog" [modal]="true" [header]="previewFileName" [dismissableMask]="true"
  [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '60vw'}">
  <div class="preview-dialog-body" style="padding: 0;">
    <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" width="100%" height="650px" style="border: none; display: block;" allowfullscreen></iframe>
    <div style="text-align: center; padding: 8px;">
      <a [href]="originalFileUrl" target="_blank" style="font-size: 13px; color: #1A237E;">
        <i class="pi pi-download"></i> Open / Download directly
      </a>
    </div>
  </div>
</p-dialog>

<!-- Document-reading modal -->
<app-linkdindetails-fetch
  *ngIf="isDocModalVisible"
  [isVisible]="isDocModalVisible"
  [autoComplete]="false"
  (onComplete)="onDocModalComplete()"
  (onCancel)="onDocModalCancel()"
  (onClose)="onDocModalClose()">
</app-linkdindetails-fetch>